import {Injectable} from '@angular/core';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {EntityLoanListDto} from '@dto/holdings/entity-loan-list.dto';
import {EntityLoanDto} from '@dto/holdings/entity-loan.dto';
import {EntityLoanViewModel} from '../view-models/entity-loan.view-model';

@Injectable({
  providedIn: 'root'
})
export class EntityLoanConverterService {

  public convert(entityCode: string, entityLoanList: EntityLoanListDto): EntityLoanViewModel[] {
    return entityLoanList.entityLoans.map(entityLoan => this.convertSingle(entityCode, entityLoan));
  }

  private convertSingle(entityCode: string, entityLoan: EntityLoanDto): EntityLoanViewModel {
    return {
      entityCode: entityCode,
      id: entityLoan.id,
      portfolioNumber: entityLoan.portfolioNumber,
      name: entityLoan.name,
      loanType: entityLoan.loanType,
      currency: entityLoan.currency,
      maturityDate: entityLoan.maturityDate ? new Date(entityLoan.maturityDate) : null,
      interestRate: entityLoan.interestRate,
      balance: new FormattedNumber(entityLoan.balance)
    };
  }
}
